import type { FunctionComponent, CSSProperties } from 'react';

import type { IPaymentProcessResponse } from '@endeavour/payment-integration';
import { RedirectMethod } from '@endeavour/payment-integration';

import { Loader } from '../../../shared/components/loader/loader';
import { createStyleHelper, createClassName } from '../../../shared/utils/class-names';
import { useMessageHandler } from '../../hooks/use-message-handler';

import styles from './iframe.module.scss';

const style = createStyleHelper(styles, 'iframe');

export interface IFrameProps {
    className?: string;
    responseModel: IPaymentProcessResponse;
}

export const Iframe: FunctionComponent<IFrameProps> = ({ className, responseModel }) => {
    const output = responseModel.redirectOutput;
    const methodType = output?.method;
    const url = methodType === RedirectMethod.GET ? output?.url : undefined;
    const sourceDoc = output?.html;

    useMessageHandler(responseModel.transactionId ?? '');

    return (
        <div className={createClassName([className, style()])}>
            <Loader className={style('loader')} />
            <iframe
                src={url}
                srcDoc={sourceDoc}
                className={style('frame')}
                style={
                    {
                        height: output?.height || 578,
                        width: output?.width || '100%',
                    } as CSSProperties
                }
            />
        </div>
    );
};
